import { Component, OnInit } from '@angular/core';
import {AuthService} from "../shared/security/auth.service";
import {Router} from "@angular/router";
// @ts-ignore
import {TranslateService} from "@ngx-translate/core";
import {LastusedService} from "../shared/model/lastused.service";
import {Observable} from "rxjs";

@Component({
  selector: 'top-menu',
  templateUrl: './top-menu.component.html',
  styleUrls: ['./top-menu.component.css']
})
export class TopMenuComponent implements OnInit {

  authInfo: AuthService;

  constructor(private authService: AuthService, private router: Router, private translate: TranslateService, private lastusedService: LastusedService) {
    //console.log('constructor TopMenuComponent');
    this.authInfo = authService;
  }

  setLanguage(lang: string) {
    this.translate.use(lang);
  }

  ngOnInit() {
  }


}
